import axios from 'axios';
import config from '~/config';
import * as customError from '~/models/error'

export const useAyahStore = defineStore('ayah', {
    state: () => ({
        ayahList: [],
        ayahListOfSurah : [],
        translateList : [],
        commentaryList : [],
        relatedHadithList : [],
        relatedVocabularyList : [],
        relatedProperNameList : [],
        relatedSubjectList : [],
        relatedAyahList : [],
        relatedAyahDocumentsList : [],
        relatedLibraryList : [],
        analysisListP1 : [],
        analysisListP2 : [],
        commentarySingle : [],
    }),
    actions: {
        async getAyahList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListAyah`;
                const requestParams = {
                    surahId: params.Id
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data?.length)
                    throw new customError.NoContent(serviceResult, url)
                this.ayahList = serviceResult.data.Data;

                return this.ayahList;
            } catch (err) {
                console.log({ err })
            }
        },
        async getAyahListOfSurah(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/AyahListBySurah`;
                const requestParams = {
                    surahId: params.surahId,
                    orthographyId : params.orthographyId
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data?.length)
                    throw new customError.NoContent(serviceResult, url)
                this.ayahListOfSurah = serviceResult.data.Data;
                return this.ayahListOfSurah;
            } catch (err) {
                console.log({ err })
            }
        },
        async getTranslateList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListTranslate`;
                const requestParams = {
                    ayahNumber : params.ayahNumber,
                    bookIds: params.bookIds ?? '',
                    language : params.language,
                    languageIds:params.languageIds ?? '',
                    order:params.order ?? 0,
                    pageNumber:params.pageNumber,
                    pageSize:params.pageSize,
                    religionIds:params.religionIds ?? '',
                    surahId:params.surahId,
                    translateTypeIds:params.translateTypeIds ?? ''
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.translateList = serviceResult.data.Data;
                return this.translateList;
            } catch (err) {
                console.log({ err })
            }
        },
        async getCommentaryList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListCommentary`;
                const requestParams = {
                    authorIds: params.authorIds ?? '',
                    ayahNumber : params.ayahNumber,
                    bookIds: params.bookIds ?? '',
                    centuryIds : params.centuryIds ?? '',
                    commentaryTypeIds: params.commentaryTypeIds ?? '',
                    language : params.language,
                    languageIds:params.languageIds ?? '',
                    order:params.order ?? 0,
                    pageNumber:params.pageNumber,
                    pageSize:params.pageSize,
                    religionIds:params.religionIds ?? '',
                    surahId:params.surahId,
                    
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.commentaryList = serviceResult.data.Data;
                return this.commentaryList;
            } catch (err) {
                console.log({ err })
            }
        },
        async getCommentarySingle(params) {
            try {
                const url = `${config.API_BASE_URL}/api/commentary/GetCommentary`;
                const requestParams = {
                    bySarAyah: true,
                    checkAuth : false,
                    id: params.id ?? '',
                    language : params.language,
                    returnUrl:''                                        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.commentarySingle = serviceResult.data.Data;
                return this.commentarySingle;
            } catch (err) {
                console.log({ err })
            }
        },

        async getRelatedHadithList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListHadithWithGrouping`;
                const requestParams = {
                    ayahNumber : params.ayahNumber,
                    bookIds: params.bookIds ?? '',
                    centuryIds : params.centuryIds ?? '',
                    hadithTypeId: params.hadithTypeId ?? '',
                    language : params.language,
                    order:params.order ?? 0,
                    pageNumber:params.pageNumber,
                    pageSize:params.pageSize,
                    religionIds:params.religionIds ?? '',
                    surahId:params.surahId,       
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.relatedHadithList = serviceResult.data.Data;
                return this.relatedHadithList;
            } catch (err) {
                console.log({ err })
            }
        },
        
        async getRelatedVocabularyList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListRelatedVocabulary`;
                const requestParams = {
                    ayahNumber : params.ayahNumber,
                    definitionId :  params.definitionId ?? 0,
                    languageId : params.languageId ?? 0,
                    orthographyId : params.orthographyId,
                    translationId: params.translationId ?? 0,
                    wordId: params.wordId ?? 0,
                    language : params.language,
                    surahId:params.surahId,       
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.relatedVocabularyList = serviceResult.data.Data;
                return this.relatedVocabularyList;
            } catch (err) {
                console.log({ err })
            }
        },

        async getRelatedProperNameList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListRelatedProperName`;
                const requestParams = {
                    ayahNumber : params.ayahNumber,
                    language : params.language,
                    order:params.order ?? 0,
                    pageNumber:params.pageNumber,
                    pageSize:params.pageSize,
                    propernameGroupIds:params.propernameGroupIds ?? '',
                    surahId:params.surahId,        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.relatedProperNameList = serviceResult.data.Data;
                return this.relatedProperNameList;
            } catch (err) {
                console.log({ err })
            }
        },
        
        async getRelatedSubjectList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/listRelatedSubject`;
                const requestParams = {
                    ayahNumber : params.ayahNumber,
                    language : params.language,
                    order:params.order ?? 0,
                    pageNumber:params.pageNumber,
                    pageSize:params.pageSize,
                    languages: params.languages ?? '',
                    subjectGroupPathOrders: params.subjectGroupPathOrders ?? '',
                    surahId:params.surahId,        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.relatedSubjectList = serviceResult.data.Data;
                return this.relatedSubjectList;
            } catch (err) {
                console.log({ err })
            }
        },
        // /ListRelatedAyah?ayahNumber=199&bookIds=&fallPlaceIds=&language=fa&order=0&pageNumber=3&pageSize=10&relatedAyahTypeId=0&surahId=2&surahIds=
        async getRelatedAyahList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListRelatedAyah`;
                const requestParams = {
                    ayahNumber : params.ayahNumber,
                    language : params.language,
                    order:params.order ?? 0,
                    pageNumber:params.pageNumber,
                    pageSize:params.pageSize,
                    relatedAyahTypeId: params.relatedAyahTypeId ?? 0,
                    bookIds: params.bookIds ?? '',
                    fallPlaceIds: params.fallPlaceIds ?? '',
                    surahIds: params.surahIds ?? '',
                    surahId:params.surahId,        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.relatedAyahList = serviceResult.data.Data;
                return this.relatedAyahList;
            } catch (err) {
                console.log({ err })
            }
        },
        async getRelatedAyahDocuments(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/AyahRelatedAyahDocuments`;
                const requestParams = {
                    ayahNumber: params.ayahNumber,
                    language: params.language,
                    relatedAyahNumber: params.relatedAyahNumber,
                    relatedSurahId: params.relatedSurahId,
                    surahId: params.surahId        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.relatedAyahDocumentsList = serviceResult.data.Data;
                return this.relatedAyahDocumentsList;
            } catch (err) {
                console.log({ err })
            }
        },
        async getRelatedLibraryList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/ListLibrary`;
                const requestParams = {
                    ayahNumber: params.ayahNumber,
                    languages: params.languages,
                    books: params.books,
                    creators: params.creators,
                    languages: params.languages,
                    publishers: params.publishers,
                    pageSize: params.pageSize,
                    pageNumber: params.pageNumber,
                    sort: params.sort,
                    subjects: params.subjects,
                    surahId: params.surahId        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.data)
                    throw new customError.NoContent(serviceResult, url)
                this.relatedLibraryList = serviceResult.data.data;
                return this.relatedLibraryList;
            } catch (err) {
                console.log({ err })
            }
        },
        async getAnalysisListP1(params) {
            try {
                const url = `${config.API_BASE_URL}/api/AnalysisSearch/RelationListV2`;
                const requestParams = {
                    ayahId: params.ayahNumber,
                    relationId: 0,
                    surahId: params.surahId        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.analysisListP1 = serviceResult.data.Data;
                return this.analysisListP1;
            } catch (err) {
                console.log({ err })
            }
        },
        async getAnalysisListP2(params) {
            try {
                const url = `${config.API_BASE_URL}/api/Ayah/RelatedRhetoric`;
                const requestParams = {
                    ayahNumber: params.ayahNumber,
                    surahNumber: params.surahId        
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data)
                    throw new customError.NoContent(serviceResult, url)
                this.analysisListP2 = serviceResult.data.Data;
                return this.analysisListP2;
            } catch (err) {
                console.log({ err })
            }
        },
    },
})